import type { SliceSet } from './types';

export interface AuditEntry {
  id: string;
  timestamp: string;
  action: string;
  details: string;
  user: string;
}

export interface AuditSlice {
  auditLog: AuditEntry[];
}

type Slice = AuditSlice;

export const createAuditSlice = (
  _set: SliceSet
): Slice => ({
  auditLog: [],
});
